import React from 'react';
import useSWR from 'swr';
import campaignEventService from '@/services/campaignEventService';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';
import { fetcherWithDataKey } from '@/utils/services';
import useOwnerOrgId from '../useOwnerOrgId';

const useEventTickets = (ticketedEventId, swrOptions) => {
  const orgId = useOwnerOrgId();
  const key =
    ticketedEventId && orgId
      ? `tickets?${joinNonEmptyParams({
          scope: 'ticketed_event',
          orgId,
          ticketedEventId,
        })}`
      : null;
  const { data, errors, mutate, isValidating } = useSWR(
    key,
    fetcherWithDataKey('tickets'),
    swrOptions,
  );

  const createTicketOption = React.useCallback(
    async (ticketData) => {
      const res = await campaignEventService.createTicketOption(
        orgId,
        ticketedEventId,
        ticketData,
      );
      mutate([res.data.ticket, ...data], { revalidate: false });
    },
    [data, mutate, orgId, ticketedEventId],
  );

  const updateTicketOption = React.useCallback(
    async (ticketId, update) => {
      const res = await campaignEventService.updateTicketOption({
        ...update,
        ticketId,
      });
      mutate(
        (data || []).map((ticket) =>
          ticket.ticketId === ticketId ? res.data.ticket : ticket,
        ),
        { revalidate: false },
      );
    },
    [data, mutate],
  );

  return { createTicketOption, data, errors, isValidating, updateTicketOption };
};

export default useEventTickets;
